// Components
import { Text } from 'yard-utilities/components'

interface TitleProps {
  children: React.ReactNode
  index: number
}

const Title = ({ children, index }: TitleProps) => {
  return (
    <Text tagName="h5" variant="body-5" spacing={{ sm: 8 }} transform="capitalize">
      {index}. {children}
    </Text>
  )
}

export default Title
